import { useQuery } from 'react-query';
import { useAuthorizedClient } from '../../contexts/Auth';
import { useMerchantId } from '../useMerchantId';
import { BankInfo } from './types';

function useMerchantBankAccount() {
  const merchantId = useMerchantId();
  const client = useAuthorizedClient();

  return useQuery(
    ['merchantBankAccount', merchantId],
    () =>
      client(`/v1/merchants/${merchantId}/bank_account`, {}).then(
        (data: BankInfo) => data
      ),
    {
      enabled: !!merchantId,
    }
  );
}

export { useMerchantBankAccount };
